// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout__component[data-v-95571864]{margin-top:45px;margin-bottom:45px}.layout__component[data-v-95571864]:first-child{margin-top:0}.layout__component[data-v-95571864]:last-child{margin-bottom:0}.layout__loader[data-v-95571864]{height:30px;margin-top:45px;display:none}.layout__loader_show[data-v-95571864]{display:block}.layout__loading[data-v-95571864]{height:30px;margin-left:auto;margin-right:auto;display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
